import styled from '@emotion/styled';
import { SM_SCREEN_MAX } from '../../../../modules/Styleguide';

const Section = styled.section`
  padding: 120px 24px;
  background: linear-gradient(#fff 0%, #fff 500px, #f2f2f4 700px, #f2f2f4 100%);
  @media (max-width: ${SM_SCREEN_MAX}px) {
    padding: 72px 16px 48px 16px;
  }
`;

const ContentContainer = styled.div`
  max-width: 926px;
  width: 100%;
  margin: auto;
`;

const HeaderContainer = styled.div`
  max-width: 430px;
  width: 100%;
`;

const SectionHeader = styled.h2`
  margin: 0;
  font-size: 3.6rem;
  line-height: 4.6rem;
  font-weight: bold;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    font-size: 3.2rem;
    line-height: 3.8rem;
  }
`;

const SectionSubHeader = styled.h3`
  margin: 12px 0 56px 0;
  color: #5f6368;
  font-size: 2rem;
  line-height: 3rem;
  font-weight: normal;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    font-size: 1.8rem;
    line-height: 2.4rem;
    margin: 18px 0 48px 0;
  }
`;

const ValuePropGrid = styled.div`
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 55px;
  grid-column-gap: 70px;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    margin-top: 48px;
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
`;

const ValuePropContainer = styled.div`
  @media (max-width: ${SM_SCREEN_MAX}px) {
    border-bottom: 1px solid #c9cbcd;
    padding-bottom: 36px;
    margin-bottom: 36px;
  }
  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const ValuePropHeader = styled.h4`
  margin: 0 0 8px 0;
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.4rem;
`;

const ValuePropParagraph = styled.p`
  margin: 0;
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #5f6368;
`;

export {
  Section,
  ContentContainer,
  HeaderContainer,
  SectionHeader,
  SectionSubHeader,
  ValuePropGrid,
  ValuePropContainer,
  ValuePropHeader,
  ValuePropParagraph,
};
